module.exports = __webpack_public_path__ + "img/IMG_0577_8_9_L_WoodMatted.f83b2d1f.jpg";